import { FC } from 'react';
import { CourseInfo } from '../../types/apis/contentsListApi';
import { convertElapsedDate } from '../../utils/convertElapsedDate';
import styles from './LessonContent.module.scss';

type Props = {
  info: CourseInfo;
  topicNumber: string;
  onClickTopicButton: (topic: string) => void;
  onClickTrainingButton: (trainingId: number, contents: CourseInfo[]) => void;
  contents: CourseInfo[];
};

const LessonContent: FC<Props> = ({
  info,
  topicNumber,
  onClickTopicButton,
  onClickTrainingButton,
  contents,
}) => (
  <>
    <li className={styles['topic-list-item']}>
      <button
        type="button"
        className={styles['topic-list-item-btn']}
        onClick={() => onClickTopicButton(info.number)}
      >
        <div className={styles['topic-list-item-left']}>
          <div className={styles['topic-list-item-upper']}>
            <div className={styles['topic-list-item-upper-left']}>
              <p>{info.number}</p>
              {info.isCompleted && (
                <figure>
                  <div
                    className={`${styles['svg-icon']} ${styles['ic-done']} ${styles['mod-20']}`}
                  />
                </figure>
              )}
            </div>
            <p className={styles['last-day']}>
              {convertElapsedDate(info.playdt)}
            </p>
          </div>
          <div className={styles['topic-list-item-lower']}>
            <p className={styles['topic-list-title']}>{info.description}</p>
          </div>
        </div>
        <div>
          <figure>
            <div
              className={`${styles['svg-icon']} ${styles['mod-32']} ${styles['ic-expand-more']}`}
            />
          </figure>
        </div>
      </button>
    </li>
    <li
      className={`${styles['topic-list-item-expandable-contents']}
        ${topicNumber === info.number ? styles['is-expanded'] : ''}
      `}
    >
      <button
        type="button"
        className={`${styles['training-type-btn']} ${styles['mod-hop']} ${
          topicNumber === info.number ? styles['is-expanded'] : ''
        }`}
        onClick={() => onClickTrainingButton(info.hopId, contents)}
      >
        Hop
      </button>
      <button
        type="button"
        className={`${styles['training-type-btn']} ${styles['mod-skip']} ${
          topicNumber === info.number ? styles['is-expanded'] : ''
        }`}
        onClick={() => onClickTrainingButton(info.skipId, contents)}
      >
        Skip
      </button>
      <button
        type="button"
        className={`${styles['training-type-btn']} ${styles['mod-jump']} ${
          topicNumber === info.number ? styles['is-expanded'] : ''
        }`}
        onClick={() => onClickTrainingButton(info.jumpId, contents)}
      >
        Jump
      </button>
    </li>
  </>
);
export default LessonContent;
